// systemCheckConstants.js
// Configuration for the Pre-Interview System Quality Check feature.
// This file is new and isolated — it is not imported by any existing interview code.

export const CHECK_STATUS = {
    PENDING: "pending",
    CHECKING: "checking",
    PASSED: "passed",
    WARNING: "warning",
    FAILED: "failed",
};

// Network latency classification (ms), based on median of NETWORK_SAMPLE_COUNT pings
export const NETWORK_THRESHOLDS = {
    GOOD_MS: 400,
    FAIR_MS: 1200,
    // anything above FAIR_MS => Poor
};
export const NETWORK_SAMPLE_COUNT = 3;
export const NETWORK_TIMEOUT_MS = 5000;

// Backend health check timeout
export const BACKEND_TIMEOUT_MS = 6000;

// Microphone: how long (ms) to sample audio energy before deciding pass/fail
export const MIC_SAMPLE_WINDOW_MS = 2500;
export const MIC_SILENCE_RMS_THRESHOLD = 0.02;

// Screen size below which we warn (not block) — matches common small-laptop width
export const MIN_DESKTOP_WIDTH = 1024;

// Speaker test: a spoken sentence (via the browser's built-in text-to-speech)
// instead of a short tone/"ting". This lets the candidate actually confirm
// they can hear intelligible speech through their output device, which is a
// closer match to what they'll need during the real interview.
export const SPEAKER_TEST_SENTENCE =
    "This is a sound check. If you can hear this sentence clearly, please click Yes, I hear it.";

// Confidence threshold used when validating that a real face is present in
// the verification photo (0–1). Higher = stricter.
export const FACE_DETECTION_SCORE_THRESHOLD = 0.5;

// Path the browser fetches face-api.js model weights from. This reuses the
// same "/models" folder already used by the in-interview face monitoring in
// AIInterview.js, so no new static assets need to be added to the project.
export const FACE_API_MODEL_URL = "/models";

// Ordered list of checks. `blocking: true` means Start Interview stays disabled
// until this check resolves to PASSED or WARNING (never on FAILED).
export const CHECK_DEFINITIONS = [
    { id: "browser", label: "Browser Compatibility", blocking: true, retryable: true },
    { id: "device", label: "Device & Screen", blocking: false, retryable: true },
    { id: "permissions", label: "Camera & Mic Permissions", blocking: false, retryable: true },
    { id: "camera", label: "Camera", blocking: true, retryable: true },
    { id: "microphone", label: "Microphone", blocking: true, retryable: true },
    { id: "speaker", label: "Speaker", blocking: true, retryable: true },
    { id: "network", label: "Internet Connection", blocking: false, retryable: true },
    { id: "backend", label: "Interview Service", blocking: true, retryable: true },
];